import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=4092657a&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.scss?vue&type=style&index=0&id=4092657a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092657a",
  null
  
)

export default component.exports